module.exports = __webpack_public_path__ + "static/media/gal-4.e66224c7.jpeg";